import { render, staticRenderFns } from "./new-password.page.vue?vue&type=template&id=82b6c0ee&scoped=true&"
import script from "./new-password.page.vue?vue&type=script&lang=js&"
export * from "./new-password.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b6c0ee",
  null
  
)

export default component.exports